export default "__VITE_ASSET__BnJJKf9x__"